import { render, staticRenderFns } from "./KioskActions.vue?vue&type=template&id=b8aa9194&"
import script from "./KioskActions.vue?vue&type=script&lang=js&"
export * from "./KioskActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports